import { render, staticRenderFns } from "./molecule.transferDesign.content.vue?vue&type=template&id=752b69e6"
import script from "./molecule.transferDesign.content.vue?vue&type=script&lang=js"
export * from "./molecule.transferDesign.content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports